import { render } from "./MakeDiagnosisSection.vue?vue&type=template&id=7be6caa7"
import script from "./MakeDiagnosisSection.vue?vue&type=script&lang=js"
export * from "./MakeDiagnosisSection.vue?vue&type=script&lang=js"

import "./MakeDiagnosisSection.vue?vue&type=style&index=0&id=7be6caa7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__